import { css } from '@emotion/css';

export const tableStyles = css`
  &.BaseTable {
    box-shadow: none;

    .BaseTable__table,
    .BaseTable__row,
    .BaseTable__footer,
    .BaseTable__body {
      background-color: var(--bg-primary);
    }

    .BaseTable__table-main {
      outline: none;
    }

    .BaseTable__body {
      will-change: unset !important;
    }

    .BaseTable__column-resizer {
      width: 2px;
      background: var(--focus-primary) !important;
    }

    .BaseTable__table-main .BaseTable__header {
      background: var(--bg-primary);
    }
  }

  &.BaseTable--dynamic .BaseTable__row {
    overflow: initial;
  }

  .BaseTable__row-cell {
    padding-left: 0;
    padding-right: 0;
  }

  .BaseTable__row--depth-1,
  .BaseTable__row--depth-2,
  .BaseTable__row--depth-3,
  .BaseTable__row--depth-4,
  .BaseTable__row--depth-5 {
    background: var(--bg-secondary);

    &:hover {
      //background: var(--bg-secondary) !important;
    }
  }

  .BaseTable__empty-layer {
    border-radius: 1.2rem;
  }

  .BaseTable__row {
    border-bottom: 1px solid var(--border);

    &:hover,
    &.BaseTable__row--hovered {
      background-color: transparent;
    }
  }

  .BaseTable__row:last-child {
    border-bottom: none;
  }

  .BaseTable__body {
    box-shadow: 0 0 0 1px var(--border);
    border-radius: 1.2rem;
  }

  .BaseTable__table-main {
    background-color: transparent !important;
  }
`;
